import { render, staticRenderFns } from "./SurveyCard.vue?vue&type=template&id=129e740a&scoped=true"
import script from "./SurveyCard.vue?vue&type=script&lang=js"
export * from "./SurveyCard.vue?vue&type=script&lang=js"
import style0 from "./SurveyCard.vue?vue&type=style&index=0&id=129e740a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129e740a",
  null
  
)

export default component.exports